import {
    Layout,
    Menu,
    Avatar,
    Button,
    Dropdown,
    Space,
    Badge,
} from "antd";
import {
    BellOutlined,
    DownloadOutlined,
    UserOutlined,
} from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { MenuList } from "./nav/MenuList";
import HeaderBar from "./HeaderBar";
// import brand_logo from '../../assets/brand_logo.png'
import brand_logo from '../../assets/brand_logo.png'

const { Header } = Layout;

export default function TopHeader({ activeParent, setActiveParent }) {
    const navigate = useNavigate();

    const parentItems = MenuList.map(item => ({
        key: item.key,
        icon: item.icon,
        label: item.label,
    }));

    const onParentClick = ({ key }) => {
        const parent = MenuList.find(i => i.key === key);
        if (!parent) return;

        setActiveParent(parent);

        if (parent.children && parent.children.length > 0) {
            navigate(parent.children[0].to);
        }
        else if (parent.to) {
            navigate(parent.to);
        }
    };


    const profileMenu = (
        <Menu
            items={[
                { key: "profile", label: "Profile" },
                { key: "settings", label: "Settings" },
                {
                    key: "logout",
                    label: "Logout",
                    danger: true,
                    onClick: () => {
                        localStorage.clear();
                        window.location.reload();
                    },
                },
            ]}
        />
    );

    return (
        <Header
            style={{
                background: "#fff",
                display: "flex",
                alignItems: "center",
                padding: "44px",
                height: 64,
                position: "sticky",
                top: 0,
                zIndex: 100,
                boxShadow: "0 1px 6px rgba(0,0,0,0.08)",
            }}
        >
            {/* Logo */}
            <div
                style={{
                    display: "flex",
                    alignItems: "center",
                    marginRight: 40,
                }}
            >
                <img
                    src={brand_logo}
                    alt="Brand Logo"
                    style={{
                        height: 60,
                        width: "auto",
                        objectFit: "contain",
                    }}
                />
</div>


            {/* Parent Menu */}
            <Menu
                mode="horizontal"
                items={parentItems}
                selectedKeys={[activeParent?.key]}
                onClick={onParentClick}
                style={{ flex: 1, borderBottom: "none" }}
            />

            {/* Right Actions */}
            {/* <Space size="middle"> */}

            <HeaderBar />

            {/* </Space> */}
        </Header>
    );
}
